import {useState} from 'react';
import {CommentEditor} from '~/ViewInvitation/routes/Guests/CommentEditor/CommentEditor';
import {Guest} from '~/ViewInvitation/routes/Guests/Guest';
import {Replies} from '~/ViewInvitation/routes/Guests/Replies';
import {Divider} from '~library/atoms/Divider';

export const ParentPost = (props) => {
  const {guest, label, parentPostId, isCommentOpen, onCommentEditorOpen, onCommentEditorClose} =
    props;

  const [postIdOfComment, setPostIdOfComment] = useState(null);

  const [isEditingComment, setIsEditingComment] = useState(false);

  const initialComment = guest.rsvp_comment || guest.comment || '';

  const handleCommentOpen = () => {
    setPostIdOfComment(parentPostId);
    onCommentEditorOpen(parentPostId);
    setIsEditingComment(false);
  };

  const handleCommentClose = () => {
    setPostIdOfComment(null);
    onCommentEditorClose();
    setIsEditingComment(false);
  };

  const handleClearComment = () => {
    // clear comment and reset UI
    handleCommentClose();
  };

  const handleSetEditing = (postIdToEdit) => {
    // if any comment in this parent's flow is being edited, show form
    // but in Guest, check if it is this ID being edited before hiding OG comment
    setIsEditingComment(true);
    onCommentEditorOpen(parentPostId);
    setPostIdOfComment(postIdToEdit);
  };
  return (
    <div
      className="wic__parent-post"
      id={guest.guest_id}
      data-qa-value={guest.guest_id}
      data-qa-id="who-is-coming-parent-post"
    >
      <Guest
        id={guest.guest_id}
        isCommentOpen={isCommentOpen}
        handleCommentOpen={handleCommentOpen}
        handleSetEditing={null}
        isEditingComment={isEditingComment}
        setCommentPostId={setPostIdOfComment}
        guest={guest}
        label={label}
        isParentPost
      />

      <Replies
        parentId={parentPostId}
        isCommentOpen={isCommentOpen}
        handleCommentOpen={null}
        handleSetEditing={handleSetEditing}
        isEditingComment={isEditingComment}
        setCommentPostId={setPostIdOfComment}
        postBeingEdited={postIdOfComment}
      />

      {!isCommentOpen && <Divider />}

      {isCommentOpen && (
        <CommentEditor
          handleClearComment={handleClearComment}
          initialComment={initialComment}
          parentPostId={parentPostId}
          postIdOfComment={postIdOfComment}
          isEditingComment={isEditingComment}
          handleSetEditing={setIsEditingComment}
          handleCommentClose={handleCommentClose}
          dataQaId="guest-comment-editor"
          id={`guestCommentsInput_${postIdOfComment || parentPostId}`}
        />
      )}
    </div>
  );
};
